import { css } from 'linaria';

export const container = css`
  margin-top: var(--space-50);
  max-width: fit-content;
`;
